import type { NotificationsChromeTranslations } from './en';

export const th: NotificationsChromeTranslations = {
  ariaBell: 'การแจ้งเตือน',
  header: 'การแจ้งเตือน',
  unreadOnly: 'เฉพาะที่ยังไม่อ่าน',
  markAllRead: 'อ่านทั้งหมด',
  emptyTitle: 'ยังไม่มีการแจ้งเตือน',
  emptyHint: 'การแจ้งเตือนใหม่จะปรากฏที่นี่เมื่อมาถึง',
  connectionConnected: 'เชื่อมต่อแล้ว',
  connectionDisconnected: 'การเชื่อมต่อขาด — คลิกเพื่อเชื่อมต่อใหม่',
  goToAdmin: 'ไปที่หน้าจัดการการแจ้งเตือน',
  tabs: {
    general: 'ทั่วไป',
    assignment: 'งานที่มอบหมาย',
    mention: 'การกล่าวถึง',
  },
  markReadFailed: 'ไม่สามารถทำเครื่องหมายเป็นอ่านแล้ว',
  markAllReadFailed: 'ไม่สามารถทำเครื่องหมายทั้งหมดเป็นอ่านแล้ว',
  newNotificationFallbackTitle: 'การแจ้งเตือนใหม่',
};
